/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithSalesRepItemRequestBuilder, WithSalesRepItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements/by-sales-rep
 */
export interface BySalesRepRequestBuilder extends BaseRequestBuilder<BySalesRepRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.commissions.statements.bySalesRep.item collection
     * @param salesRepId Unique identifier of the item
     * @returns {WithSalesRepItemRequestBuilder}
     */
     bySalesRepId(salesRepId: string) : WithSalesRepItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const BySalesRepRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements/by-sales-rep";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const BySalesRepRequestBuilderNavigationMetadata: Record<Exclude<keyof BySalesRepRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySalesRepId: {
        requestsMetadata: WithSalesRepItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["salesRepId"],
    },
};
/* tslint:enable */
/* eslint-enable */
